const IDELIO_API_URL = process.env.NEXT_PUBLIC_IDELIO_API_URL;

export interface IdelioPayload {
  agenceId: number;
  prospect: {
    pays: string;
    numero: string;    // numéro SAISI par l’utilisateur
    ip?: string;
    cookie?: string;
    adresse?: string;
    nom?: string;
    prenom?: string;
  };
}

type Agency = {
  id?: number;
  slug?: string;
  lmsName?: string;
  name?: string;
  adresse?: string;
  phone?: string;
  phoneIdelio?: string;
  showIdelioButton?: boolean;
};

class IdelioService {
  async sendCall(payload: IdelioPayload) {
    try {
      const response = await fetch(IDELIO_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Erreur Idelio: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Erreur API Idelio :", error);
      throw error;
    }
  }

  // Méthode pour récupérer le statut via l'UUID de l'APIBackend
  async getStatusIdelio(uuid: string) {
    try {
      const uuidClean = uuid;
      const apiBase = process.env.NEXT_PUBLIC_API_URL;

      const endpoint = new URL(`lms/agencies/${encodeURIComponent(uuidClean)}`, apiBase).toString();
      const responseUuid = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!responseUuid.ok) {
        throw new Error(`Erreur récupération ID LMS (HTTP ${responseUuid.status})`);
      }
       
      const agencyData = await responseUuid.json();
      const idelioId = agencyData.id;

      if (!idelioId) {
        throw new Error(`ID Idelio introuvable pour l'UUID : ${uuid}`);
      }

      const endpointIdelio = new URL(`lmsAgency/${encodeURIComponent(idelioId)}`, apiBase).toString();
      const responseStatus = await fetch(endpointIdelio, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });
      
      if (!responseStatus.ok) {
        throw new Error(`Erreur récupération statut Idelio (HTTP ${responseStatus.status})`);
      }

      const agencyResponse = await responseStatus.json();
      console.log('agencyResponse',agencyResponse)
       localStorage.removeItem("agencyIdelio");
      // Construction propre de l'objet agence avec le champ showIdelioButton inclus
      const agencyIdelio: Agency = {
        id: idelioId || "",
        slug: agencyResponse.slug || "",
        lmsName: agencyResponse.name || "",
        adresse: [
          agencyResponse.street,
          agencyResponse.postcode,
          agencyResponse.city,
          "France"
        ].filter(Boolean).join(", "),
        phone: agencyResponse.phone || "",            
        phoneIdelio: agencyResponse.phoneIdelio || "",
        showIdelioButton: Boolean(agencyResponse.showIdelioButton),
      };
      
     
      localStorage.setItem("agencyIdelio", JSON.stringify(agencyIdelio));
      const storedAgency = localStorage.getItem("agencyIdelio");
      console.log('storedAgency',storedAgency)
      return agencyResponse.showIdelioButton;
    } catch (error) {
      console.error("Erreur dans getStatusIdelio :", error);
      throw error;
    }
  }
}

export const idelioService = new IdelioService();